import React from 'react';
import cn from 'classnames';
import styles from './TabNavigation.module.scss';
import { KeyboardShortcut, Key } from '@repo/components/tooltips';
import { useHotkeyHandler } from '@repo/hooks';

interface Tab {
  index: number;
  title: string;
  shortcut?: string;
}

export default function TabNavigation({
  tabs,
  activeTabIdx,
  setActiveTabIdx,
  className,
  children,
}: {
  tabs: Tab[];
  activeTabIdx: number;
  setActiveTabIdx: (tab: number) => void;
  className?: string;
  children?: React.ReactNode;
}) {
  useHotkeyHandler(
    {
      handler: (e) => {
        if (e.defaultPrevented) {
          return;
        }

        const keyAsIdx = (parseInt(e.key) || 0) - 1;

        if (!!tabs[keyAsIdx] && keyAsIdx !== activeTabIdx) {
          e.preventDefault();
          setActiveTabIdx(keyAsIdx);
          return;
        }
      },
    },
    [tabs, activeTabIdx],
  );

  return (
    <div className={cn(styles.tabs, className)}>
      {tabs.map(({ title, index }) => (
        <KeyboardShortcut key={index} placement="bottom" shortcut={<Key>{index + 1}</Key>}>
          <div className={cn(styles.tab, index === activeTabIdx && styles.tabActive)}>
            <button
              className={cn(styles.tabButton, 'btn-none')}
              onClick={(e) => {
                e.preventDefault();
                setActiveTabIdx(index);
              }}
            >
              {title}
            </button>
          </div>
        </KeyboardShortcut>
      ))}
      {children && <div className={styles.tabMenuContent}>{children}</div>}
    </div>
  );
}
